export default __webpack_public_path__ + "static/media/trabecular.c77b2db1.png";